export default {
      id: "icon_mbj-usage",
      viewBox: "0 0 35 20",
      url: __webpack_public_path__ + "sprite.svg#icon_mbj",
      toString: function () {
        return this.url;
      }
    }